import { handleJsonResponse, requestGet, SERVICE_URL } from 'util/request';

export const requestAllRoles = () => requestGet(`${SERVICE_URL}/roles/`).then(handleJsonResponse);
